export const GET_DOCUMENT_SIGNATURE_LIST = "GET_DOCUMENT_SIGNATURE_LIST";
export const DOCUMENT_SIGNATURE_LIST = "DOCUMENT_SIGNATURE_LIST";

export const SEARCH_DOCUMENT_SIGNATURE_BY_ID =
  "SEARCH_DOCUMENT_SIGNATURE_BY_ID";
export const DOCUMENT_SIGNATURE_BY_ID = "DOCUMENT_SIGNATURE_BY_ID";

export const SEARCH_DOCUMENT_SIGNATURE_BY_FIELD =
  "SEARCH_DOCUMENT_SIGNATURE_BY_FIELD";
export const DOCUMENT_SIGNATURE_BY_FIELD_LIST =
  "DOCUMENT_SIGNATURE_BY_FIELD_LIST";

export const SAVE_DOCUMENT_SIGNATURE = "SAVE_DOCUMENT_SIGNATURE";
export const SAVE_DOCUMENT_SIGNATURE_RESPONSE =
  "SAVE_DOCUMENT_SIGNATURE_RESPONSE";

export const UPDATE_DOCUMENT_SIGNATURE = "UPDATE_DOCUMENT_SIGNATURE";
export const UPDATE_DOCUMENT_SIGNATURE_RESPONSE =
  "UPDATE_DOCUMENT_SIGNATURE_RESPONSE";

export const DELETE_DOCUMENT_SIGNATURE = "DELETE_DOCUMENT_SIGNATURE";
export const DELETE_DOCUMENT_SIGNATURE_RESPONSE =
  "DELETE_DOCUMENT_SIGNATURE_RESPONSE";

export const RESEND_DOCUMENT_SIGNATURE = "RESEND_DOCUMENT_SIGNATURE";
export const RESEND_DOCUMENT_SIGNATURE_RESPONSE =
  "RESEND_DOCUMENT_SIGNATURE_RESPONSE";

export const REFRESH_SIGNATURE_STATUS = "REFRESH_SIGNATURE_STATUS";
export const REFRESH_SIGNATURE_STATUS_RESPONSE =
  "REFRESH_SIGNATURE_STATUS_RESPONSE";
